import type { AxiosPromise } from "axios";
import type BackOfficeConnector from "../data/backOfficeConnector";
import type RevenueSourceType from "../entities/revenueSourceType";
import type Month from "../entities/month";
import type EventBus from "../services/eventBus";
import RepositoryBase from "./repositoryBase";
import { serializeFilters } from "../utils/filters";

export default class ReportRepository extends RepositoryBase<BackOfficeConnector> {
  constructor(protected apiFactory: ReturnType<typeof BackOfficeConnector.Factory>, protected eventBus: EventBus) {
    super(apiFactory, eventBus);
  }

  dailyCharges(from: Date, to: Date) {
    return this.callApi(api =>
      api.all("reports").all("daily_charges").get({ from_order_date: from.toISOString(), to_order_date: to.toISOString() })
    );
  }

  monthlyExpenses(month: Month): AxiosPromise {
    return this.callApi(
      api =>
        api.all("finance").all("monthly_expenses").all("report").postOnly({
          year: month.year,
          month: month.month,
        }) as any
    );
  }

  monthlyRevenues(month: Month, revenueSourceType: RevenueSourceType): AxiosPromise {
    return this.callApi(
      api =>
        api
          .all("finance")
          .all("monthly_revenues")
          .all("report")
          .postOnly({ year: month.year, month: month.month, revenueSourceType }) as any
    );
  }

  unreturnedRefundsOfRefunds(fromDate: Date, toDate: Date): AxiosPromise {
    return this.callApi(
      api =>
        api
          .all("finance")
          .all("unreturned_refunds_of_refunds")
          .all("report")
          .getRaw(serializeFilters({ fromDate, toDate })) as any
    );
  }
}
